import { isNil } from 'lodash'

type ReturnType<T> = T extends null | undefined ? undefined : string | number
export const formatNumber = <T extends string | number | null | undefined>(
  value: T,
): ReturnType<T> => {
  if (isNaN(Number(value))) {
    return value as ReturnType<T>
  }
  if (isNil(value)) {
    return value as ReturnType<T>
  }

  const formatterUS = new Intl.NumberFormat('en-US', { maximumFractionDigits: 6 })

  return formatterUS.format(Number(value)) as ReturnType<T>
}
